import {BotaoSalvar, PaginaLogada} from "../../componentes";
import {useEffect, useState} from "react";
import {Card} from "../../componentes/card/Card";
import CardHeader from "react-bootstrap/CardHeader";
import {ItemDemandaServico, ItemServico} from "../../servicos";
import ListarNomes from "../../componentes/ListarNomes";
import {exibirMensagemErro, exibirMensagemSucesso} from "../../util";

export default function CadastrarItemDemanda() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [itens, setItens] = useState([])
  const [buscar, setBuscar] = useState('')

  const [nomeItem, setNomeItem] = useState('')

  function carregarItens() {
    setIsCarregando(true)
    ItemDemandaServico.getItens()
      .then(dados => setItens(dados))
      .finally(() => setIsCarregando(false))
  }

  function salvarItem(e) {
    e.preventDefault()
    if (!nomeItem) {
      exibirMensagemErro('Um nome de item precisa ser informado')
      return
    }

    setIsCarregando(true)
    const dados = {
      'nome': nomeItem
    }
    ItemDemandaServico.cadastrarItem(dados)
      .then(res => {
        setItens([...itens, res] )
        exibirMensagemSucesso(`${nomeItem} cadastrado com sucesso.`)
        setNomeItem('')
      })
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    carregarItens()
  }, [])

  return (
    <PaginaLogada isCarregando={isCarregando}>
      <Card titulo="Cadastrar item DOD">
        <div className="row">
          <div className="col-lg-6">
            <input
              autoComplete="off"
              className="form-control"
              value={nomeItem}
              placeholder="Nome do item"
              onChange={(e) => setNomeItem(e.target.value.toString().toUpperCase())}/>
          </div>
          <div className="col-lg-6">
            <BotaoSalvar onClick={salvarItem}/>
          </div>
        </div>
      </Card>
      <Card titulo="Itens Cadastrados">
        <CardHeader>
          <div className="row">
            <div className="col-lg-4">
              <input
                autoComplete="off"
                placeholder="Buscar"
                value={buscar}
                onChange={(e) => setBuscar(e.target.value.toString().toUpperCase())}
                className="form-control"/>
            </div>
          </div>
        </CardHeader>
        <ListarNomes nomes={itens.filter(v => buscar ? v.nome.startsWith(buscar) : true)}/>
      </Card>
    </PaginaLogada>
  )
}